import { archiveStrategyAction } from "fleet/redux-store/strategies";
import { StrategyV2ListPage } from "fleet/view/strategy-v2/list";
import { connect } from "react-redux";
import { getAuthUser } from "redux-store/auth";

function mapStateToProps(state) {
  const { app, global, pages } = state;
  const user = getAuthUser(state);

  return {
    user,
    applications: global.applications,
    userContents: global.userContents,
    contentGroups: app.contentGroups,
    strategies: app.strategies,
    strategy: pages.strategyDetail.strategy,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    archiveStrategy: (strategyId, archiveStatus, successMsg) => {
      dispatch(archiveStrategyAction(strategyId, archiveStatus, successMsg));
    },
  };
}

const ConnectedStrategyV2ListPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StrategyV2ListPage);

export { ConnectedStrategyV2ListPage };
